import React, { useState }from 'react';
import SftGlobalData from '../../library/SftGlobalData';
import axios from 'axios';
import { Switch } from '@mui/material';

const LicenceCheckBox = (props) =>  { 
    const [checked, setChecked] = useState(props.checked);
    const [clientModId, setClientModId] = useState(props.mod.id);

    const changeListener = () => {
        if(props.mod.mod_id == 61 && !checked){
            props.onOpenModal(true);
        }else{
            updateModule({key: props.api, database: props.database, mod_id: props.mod.mod_id, client_mod_id: clientModId, user: props.username, sftUserId: props.userId});
            setChecked(!checked);
        }
    }

    const updateModule = (postData) => {
        SftGlobalData.post('client&action=updateModules', postData).then(response => {
            try{
                if(response.data.message === "success" && clientModId === null){
                    setClientModId(response.data.id);
                }
            }catch(e){
                
            }
        });
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', alignContent: 'center', justifyContent: 'center' }}>
            <Switch
                disabled={props.disabled}
                checked={checked}
                onChange={() => { changeListener(); }}
                inputProps={{ 'aria-label': 'controlled' }}
            />
            {props?.label}
        </div>
    );
}

export default LicenceCheckBox;
